import React, { Suspense } from 'react';
import { prop, pick } from 'ramda';
import * as urlUtil from 'js/utils/url.util';
import { Link } from 'js/components/common/Link';
import { Icon } from 'js/components/common/Icon';
import { Balance } from 'js/components/main/Balance';
import { AccessibilityElement } from 'js/components/common/AccessibilityElement';
import { useAppSelector, useUserSelector, useDeviceSelector } from 'js/store/hooks';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as hooks from '../../hooks';

import style from './MyBalance.scss';

export const MyBalance: React.FC = () => {
    const translate = useComponentTranslations();
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const showBalancePopup = hooks.useShowLowBalancePopup();
    const balancePage = useAppSelector(prop('balancePage'));
    const { showLowBalancePopup, hideBalance, lowBalanceHighlight } = useUserSelector(pick([
        'showLowBalancePopup', 'hideBalance', 'lowBalanceHighlight'
    ]));
    const hideBalanceByUrl = urlUtil.getLocationParam('showHeaderOnlyOnMobile') === '1';

    if (!isDesktop && hideBalanceByUrl) {
        return null;
    }

    const content = (
        <>
            {isDesktop && (
                <Icon
                    type="headerUserBalance"
                    aria-label={translate('header.balance.aria-label')}
                    className={`${style.icon} ${style.desktopIcon} cms-icon-balance`}
                />
            )}
            {!hideBalance && (
                <span className={`${style.balance} ${lowBalanceHighlight ? style.balanceLow : ''} fn-main-header-user-balance`}>
                    <Suspense fallback="">
                        <Balance type="casino_gaming_balance" />
                    </Suspense>
                </span>
            )}
            {!isDesktop && (
                <Icon
                    type="headerMobileUserBalance"
                    className={`${style.icon} cms-icon-balance`}
                    aria-label={translate('header.balance.aria-label')}
                />
            )}
        </>
    );

    if (showLowBalancePopup) {
        return (
            <AccessibilityElement onClick={showBalancePopup} className={style.balanceWrapper}>
                {content}
            </AccessibilityElement>
        );
    }

    if (balancePage) {
        return (
            <Link href={balancePage} className={style.balanceWrapper}>
                {content}
            </Link>
        );
    }

    return null;
};
